import React, { useEffect, useState } from 'react'
import { Box } from '@chatterbug/aaron'

import explosionIcon from '../assets/explosion.svg'
import {
  BarHeights,
  COMMON_PROPS,
  HEIGHTS,
} from 'src/ui/ProgressBar/ProgressBar'

const COLORS = {
  progress: 'yellow65',
  completed: 'green36',
}

const CompletedBar: React.FC<{
  size: BarHeights
}> = ({ size }) => {
  const [width, setWidth] = useState('60%')
  const [background, setBackground] = useState(COLORS.progress)
  const [iconOpacity, setIconOpacity] = useState(0)

  useEffect(() => {
    let timerBackground: number = null
    const timerWidth = window.setTimeout(() => {
      setWidth('100%')
      timerBackground = window.setTimeout(() => {
        setBackground(COLORS.completed)
        setIconOpacity(1)
      }, 400)
    }, 100)

    return () => {
      window.clearTimeout(timerWidth)
      window.clearTimeout(timerBackground)
    }
  }, [setWidth, setBackground, setIconOpacity])

  return (
    <Box
      height={HEIGHTS[size]}
      {...COMMON_PROPS}
      bg={background}
      width={width}
      sx={{
        position: 'relative',
        transition: 'width 0.5s ease, background 0.3s ease',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          right: '-7px',
          top: '-7px',
          width: '12px',
          height: '13px',
          backgroundImage: `url(${explosionIcon})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
          opacity: iconOpacity,
          transform: `scale(${iconOpacity})`,
        }}
      />
    </Box>
  )
}

const Bar: React.FC<{
  animateCompletion?: boolean
  completeFraction: number
  size: BarHeights
}> = ({ animateCompletion, completeFraction, size }) => {
  const completed = completeFraction >= 100
  if (animateCompletion && completed) {
    return <CompletedBar size={size} />
  }

  return (
    <Box
      {...COMMON_PROPS}
      height={HEIGHTS[size]}
      bg={completed ? COLORS.completed : COLORS.progress}
      width={completeFraction ? `${Math.min(completeFraction, 100)}%` : 0}
    />
  )
}

export default Bar
